import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  if (!permissions) {
    return <Navigate to="/login" />;
  };
  
  const userPermissions = permissions || [];
  if (requiredPermission && !userPermissions.includes(requiredPermission)) {
    return <Navigate to="/login" />;
  };

  return children;
};

export default ProtectedRoute;
